import { Box } from "@material-ui/core";
import React from "react";
import BackButton from "./BackButton";

type Props = {
  to?: string;
};

export default function BackNavigation({ to }: Props) {
  return (
    <Box marginBottom={2}>
      <BackButton to={to}>Back</BackButton>
    </Box>
  );
}
